export default __webpack_public_path__ + "static/media/contextualTargeting.6af2e7a8.png";